import * as React from "react"
import * as moment from "moment"
import AmortizationTableComponent, { DataRow } from "./amortization-table-component"
import { Loan, RateVariation, InterestVariation, ReimboursedCapitalVariation } from "../../../../model"
import {
	getDecompositionall,
	getRateVariation,
	getInterestVariation,
	getInterestVariationIndex,
	getRateVariationIndex,
	getReimboursedCapitalVariation,
	getReimboursedCapitalVariationIndex
} from "../../../../domain/sfp/loan-domain"

export default class AmortizationTable
extends React.Component<AmortizationTableProps, State> {
	constructor(props) {
		super(props)
		this.state = { data: [] }
	}

	componentDidMount() {
		this.initData(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.initData(nextProps)
	}

	render() {
		return <AmortizationTableComponent
		data={this.state.data}
		isAddContext={this.props.isAddContext}
		isEditContext={this.props.isEditContext}
		isViewContext={this.props.isViewContext}
		loan={this.props.loan}
		onChange={(cells, source) => this.handleChange(cells, source)} />
	}

	private handleChange(
		cells: [number, string, number, string][],
		source: string
	): void {
		if ("edit" === source || "Autofill.fill" === source) {
			const loan = this.props.loan

			cells.forEach(([paymentDateIndex, prop, oldval, newVal]) => {
				const value = "" !== newVal ? parseFloat(newVal) : null

				switch (prop) {
					case "interest":
						const interestVariations = this.updateInterestVariations(loan, paymentDateIndex, value)
						this.props.onInterestVariationsChange(interestVariations)
						break;
					case "rateVariation.rate":
						const rateVariations = this.updateRateVariations(loan, paymentDateIndex, value/100)
						this.props.onRateVariationsChange(rateVariations)
						break;
					case "reimboursedCapital":
						const reimboursedCapitalVariations = this.updateReimboursedCapitalVariations(loan, paymentDateIndex, value)
						this.props.onReimboursedCapitalVariationsChange(reimboursedCapitalVariations)
						break;
				}
			})
		}
	}

	private initData(props: AmortizationTableProps): void {
		if (!props.loan) return
		const loan = props.loan
		const data=[]
		const decomposition = getDecompositionall(loan)
		let rateVariation = undefined
		// const rateVariation = getRateVariation(loan, 0)
		decomposition.paymentDates.map((date, i) => {
			rateVariation = getRateVariation(loan, i) ? getRateVariation(loan, i).rate : rateVariation
			data.push({
				paymentDate: moment(date).format("DD/MM/YYYY"),
				remainingCapital: decomposition.remainingCapitals[i],
				rateVariation: getRateVariation(loan, i) || this.generateRateVariation(i,rateVariation),
				periodicRate: decomposition.periodicRates[i],
				interest: decomposition.interests[i],
				reimboursedCapital: decomposition.reimboursedCapitals[i],
				paymentAmount: decomposition.paymentAmounts[i]
			})	
	  })
		this.setState({ data })
	}

	private updateInterestVariations(
		loan: Loan,
		paymentDateIndex: number,
		interest: number
	): InterestVariation[] {
		const interestVariation = getInterestVariation(loan, paymentDateIndex)

		if (null === interest && interestVariation) {
			const index = getInterestVariationIndex(loan, interestVariation)
			loan.interestVariations.splice(index, 1)
		} else if (null !== interest && !interestVariation) {
			loan.interestVariations.push({ id: null, interest, paymentDateIndex })
		} else if (interestVariation) {
			interestVariation.interest = interest
		}

		return loan.interestVariations
	}

	private updateRateVariations(
		loan: Loan,
		paymentDateIndex: number,
		rate: number
	): RateVariation[] {
		const rateVariation = getRateVariation(loan, paymentDateIndex)
		const index = rateVariation ? getRateVariationIndex(loan, rateVariation) : null

		if (null === rate && rateVariation) {
			loan.rateVariations.splice(index, 1)
		} else if (null !== rate && !rateVariation) {
			loan.rateVariations.push({ id: null, paymentDateIndex, rate })
		} else if (rateVariation) {
			loan.rateVariations[index].rate = rate
		}

		return loan.rateVariations
	}

	private generateRateVariation(
		paymentDateIndex: number,
		rate: number
	): RateVariation {
		return { id: null, paymentDateIndex, rate }
	}

	private updateReimboursedCapitalVariations(
		loan: Loan,
		paymentDateIndex: number,
		reimboursedCapital: number
	): ReimboursedCapitalVariation[] {
		const reimboursedCapitalVariation = getReimboursedCapitalVariation(loan, paymentDateIndex)

		if (null === reimboursedCapital && reimboursedCapitalVariation) {
			const index = getReimboursedCapitalVariationIndex(loan, reimboursedCapitalVariation)
			loan.reimboursedCapitalVariations.splice(index, 1)
		} else if (null !== reimboursedCapital && !reimboursedCapitalVariation) {
			loan.reimboursedCapitalVariations.push({ id: null, paymentDateIndex, reimboursedCapital })
		} else if (reimboursedCapitalVariation) {
			reimboursedCapitalVariation.reimboursedCapital = reimboursedCapital
		}

		return loan.reimboursedCapitalVariations
	}
}

export interface AmortizationTableProps {
	loan: Loan,
	isAddContext: boolean
	isEditContext: boolean
	isViewContext: boolean
	onInterestVariationsChange(interestVariations: InterestVariation[]): void
	onRateVariationsChange(rateVariations: RateVariation[]): void
	onReimboursedCapitalVariationsChange(reimboursedCapitalVariations: ReimboursedCapitalVariation[]): void
}

export interface State {
	data: DataRow[]
}


// WEBPACK FOOTER //
// ./src/component/debt/loan-detail/amortization-table/index.tsx